<template>
    <div>
        <Pos_edit_promotion />
    </div>
</template>
  
<script>
import Pos_edit_promotion from "@/components/adminArin/pos_system/warehouse/manage_promotion/Pos_edit_promotion";
export default {
    name: "PosEditPromotion",
    components: {
        Pos_edit_promotion
    }
}
</script>
  
<style scoped></style>
  